import React from 'react';

const Us1_mid_for = () => {
  return (
    <div>
      
    </div>
  );
}

export default Us1_mid_for;
